import { useState } from "react";
import axios from "axios";
import "../App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function RegisterPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    try {
      await axios.post(`${BACKEND_URL}/register`, {
        username,
        password,
      });
      setSuccess("Registration successful! You can now log in.");
      setUsername("");
      setPassword("");
      setConfirm("");
    } catch (err) {
      if (err.response && err.response.status === 409) {
        setError("Username already exists");
      } else {
        setError("Registration failed");
      }
    }
  };

  return (
    <div className="login-container center login-center">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2 className="login-title">Register</h2>
        {error && <div className="login-error">{error}</div>}
        {success && <div className="login-success">{success}</div>}
        <label>
          Username
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            className="login-input"
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="login-input"
          />
        </label>
        <label>
          Confirm Password
          <input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            required
            className="login-input"
          />
        </label>
        <button type="submit" className="login-button">Register</button>
        <a href="/login" className="login-link">Login</a>
      </form>
    </div>
  );
}